import { Injectable } from "@angular/core";
import { ApiService } from "../base/api-base.service";
import { NetworkStatusService } from "../network-status.service";
import { FeatureFlagContractService } from "./feature-flag.contract.service";
import { FeatureFlagOfflineService } from "./feature-flag.offline.service";
import { FeatureFlagOnlineService } from "./feature-flag.online.service";
import { FEATURE_FLAGS } from "../../app.constants";
import { mergeMap, skip, tap } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class FeatureFlagService extends ApiService<FeatureFlagContractService> implements FeatureFlagContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: FeatureFlagOfflineService,
    protected onlineService: FeatureFlagOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
    this.networkStatusService.applicationMode$
      .pipe(
        skip(1),
        mergeMap(() => this.fetchAndUpdate())
      )
      .subscribe();
  }

  fetchAndUpdate() {
    return this.service.fetchAndUpdate();
  }

  isFlagEnabled(flagName: FEATURE_FLAGS) {
    return this.service.isFlagEnabled(flagName);
  }
}
